var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recovery-card",on:{"click":function($event){return _vm.$emit('check-type')}}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }